namespace SP {

    export async function get<T>(url: string, callback: (result: any) => any = null) {

        const response = await fetch(url, {
            method: 'GET',
            cache: "no-store",
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'pragma': 'no-cache',
                'cache-control': 'no-store',
            }
        });

        //const response = await fetch(url);

        if (!response.ok) {
            console.log(response);
        }

        var result = await response.json();

        if (callback != null) callback(result);

        return SP.promise<T>(result);
    }
}